import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css2?family=Darker+Grotesque:wght@400;700&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Cutive+Mono&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Handlee&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Gwendolyn:wght@400;700&display=swap'); /* Dodano czcionkę Gwendolyn */
  @import url('https://fonts.googleapis.com/css2?family=Markazi+Text:wght@400;700&display=swap'); /* Dodano czcionkę Markazi Text */
  @import url('https://fonts.googleapis.com/css2?family=Cormorant:wght@300&display=swap'); /* Dodano czcionkę Cormorant Light 300 */

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: 'Cutive Mono', monospace;
    background-color: #f0f0f0;
    color: #333;
    scroll-behavior: smooth;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Darker Grotesque', sans-serif;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  .handlee-font {
    font-family: 'Handlee', cursive;
  }

  .gwendolyn-font {
    font-family: 'Gwendolyn', cursive; /* Styl dla elementów z czcionką Gwendolyn */
  }

  .markazi-text-font {
    font-family: 'Markazi Text', serif; /* Styl dla elementów z czcionką Markazi Text */
  }

  .cormorant-font {
    font-family: 'Cormorant', serif; /* Styl dla elementów z czcionką Cormorant */
    font-weight: 300; /* Light 300 */
  }
`;

export default GlobalStyles;